<template>
  <tr>
    <td>
      <b-field>
        <b-autocomplete
          expanded
          v-model="receiptSearchText"
          placeholder="Buscar receita por lote"
          field="receipt"
          :data="receiptList"
          :loading="isFetching"
          @typing="getReceiptAsyncData"
          @select="selectReceipt"
        >
          <template slot-scope="props">
            <div>{{ props.option.receipt }}</div>
            <div>{{ props.option.batch }} - {{ props.option.packingSize }}g</div>
          </template>
          <template slot="empty">
            Nenhum resultado encontrado
          </template>
        </b-autocomplete>
      </b-field>
    </td>
    <td>{{ deliveryProduct.packedProduct.batch }}</td>
    <td>{{ deliveryProduct.packedProduct.packingSize }}</td>
    <td>
      <input type="number" class="input" v-model="deliveryProduct.quantity" />
    </td>
    <td @click="removeItem"><i class="mdi mdi-window-close" style="cursor: pointer;"></i></td>
  </tr>
</template>

<script>
import QueryBuilder from "../../helpers/QueryBuilder";
import utils from "../../helpers/debounce";
import DefaultCRUDService from "../../services/DefaultCRUDService";
export default {
  name: "DeliveryProductComponent",
  props: ["item"],
  data: function() {
    return {
      deliveryProduct: this.item,
      isFetching: false,
      receiptList: [],
      receiptSearchText: "",
      selectedReceipt: {}
    };
  },
  methods: {
    selectReceipt(option) {
      if(option) {
        this.deliveryProduct.packedProduct = option;
        this.deliveryProduct.quantity = 0;
      }
    },
    removeItem() {
      this.$emit("removeProduct", this.deliveryProduct);
    },
    getReceiptAsyncData: utils.debounce(function(name) {
      this.receiptList = [];
      let query = {
        batch: name,
        size: 25
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      DefaultCRUDService.getItems("/packedproducts", query)
        .then(({ data }) => {
          this.receiptList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300)
  },
  created() {
    if (!this.deliveryProduct.packedProduct.receipt) {
      this.deliveryProduct.packedProduct.receipt = "";
    }else{
      this.receiptSearchText = this.deliveryProduct.packedProduct.receipt;

    }
  }
};
</script>

<style lang="scss" scoped>
input {
  max-width: 100px;
}
</style>
